import { createContext, useEffect, useState } from "react";
import { fetchUserGeo } from "../utils/geo";
import { STORES } from "../config/stores";

export const GeoContext = createContext(null);

export const GeoProvider = ({ children }) => {
  const [store, setStore] = useState(null);
  const [loadingGeo, setLoadingGeo] = useState(true);

  useEffect(() => {
    let mounted = true;

    async function init() {
      setLoadingGeo(true);

      // Fetch geo info (already encrypted + sanitized)
      const geo = await fetchUserGeo();
      if (!mounted) return;

      // Ensure storeId is numeric for mapping
      const storeIdNum = Number(geo.storeId) || 1;
      const decryptedStore = STORES[storeIdNum] || STORES[1];

      setStore({
        id: storeIdNum,
        name: decryptedStore.name,
        countryCode: decryptedStore.countryCode,
        currency: decryptedStore.currency,
        currencyName: decryptedStore.currencyName,
      });

      setLoadingGeo(false);
    }

    init();
    return () => (mounted = false);
  }, []);

  // Optional restricted setter (admins or forced changes)
  const setStoreInternal = (newStoreObj) => {
    const storeIdNum = Number(newStoreObj.id) || 1;
    const validatedStore = STORES[storeIdNum] || STORES[1];

    const updatedStore = {
      id: storeIdNum,
      name: validatedStore.name,
      countryCode: validatedStore.countryCode,
      currency: validatedStore.currency,
      currencyName: validatedStore.currencyName,
    };

    // Save encrypted geo in localStorage via fetchUserGeo convention
    localStorage.setItem(
      "app_geo_v1",
      JSON.stringify({ ...updatedStore, timestamp: Date.now() })
    );

    setStore(updatedStore);
  };

  return (
    <GeoContext.Provider value={{ store, loadingGeo, setStoreInternal }}>
      {children}
    </GeoContext.Provider>
  );
};
